import { create } from 'zustand';
import api from '../config/axios';
import { InquiryForm } from '../types';

interface InquiryState {
  inquiries: InquiryForm[];
  addInquiry: (formData: InquiryForm) => Promise<void>;
}

export const useInquiryStore = create<InquiryState>((set) => ({
  inquiries: [],
  addInquiry: async (formData: InquiryForm) => {
    try {
      const response = await api.post('/api/inquiries', formData);
      if (response.data.success) {
        set((state) => ({
          inquiries: [...state.inquiries, formData],
        }));
      }
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      throw error;
    }
  },
}));

